import multiiconbtn from "../icons/multiple_buttons";
// import './editor.scss';

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls,
    BlockControls,
    AlignmentToolbar,
    BlockAlignmentToolbar,
    RichText, InnerBlocks, useBlockProps } = wp.editor;
const { PanelBody, PanelRow,
    TextControl, SelectControl, RangeControl } = wp.components;


// const ALLOWED_BLOCKS = ['core/button']
registerBlockType('blocksbakery/multibuttons', {
    title: __('Multi Buttons', 'blocks-bakery'),
    description: __(
        'This block allows you to add multiple buttons with a single block.',
        'blocks-bakery'
    ),

    // common, formatting, layout, widgets, embed
    category: 'common',
    icon: multiiconbtn.multi_button,
    keywords: [
        __('Multibutton', 'blocks-bakery'),
        __('Multi', 'blocks-bakery')
    ],
    supports: {
        html: false
    },
    attributes: {
        // general
        alignmenttool: {
            type: 'html',
            default: 'center'
        },

        stackon: {
            type: 'string'
        },
        multi_btn_weight: {
            type: 'number'
        },
        font_family: {
            type: 'string',
            default: 'default'
        }
    },

    edit: (props) => {
       

     
        return [
            <div className="bb-multibuttons-parent" style={{ 
      
                  backgroundColor:"red",
            }}>
                <div  ClassName="bb-multipulebutton">
                    <InnerBlocks
                  
                        allowedBlocks={['blocksbakery/innerbutton']}
                        template={[
                            ['blocksbakery/innerbutton'],
                            
                        ]}

                    />
                </div>

                <InspectorControls>
                    <PanelBody title={__("General")} initialOpen={false}>
                        <span>Alignment</span>
                        <AlignmentToolbar
                            value={props.attributes.alignmenttool}
                            onChange={(new_val) => {
                                props.setAttributes({ alignmenttool: new_val })
                                
                                    if (new_val === 'center'){
                                        props.setAttributes({alignmenttool: 'center'})
                                    }
                                    if (new_val === 'left'){
                                        props.setAttributes({alignmenttool: 'flex-start'})
                                    }
                                    if (new_val === 'right'){
                                        props.setAttributes({alignmenttool: 'flex-end'})
                                    }
                                
                            }}
                        />

                  
                   

                        <PanelRow
                        >

                            <h3>Typography</h3>
                        </PanelRow>


                    
              
                    </PanelBody>
                </InspectorControls>

            </div>
        ]

    },

    save: (props) => {
        return (
            <div className="bb-multibuttons-parent">
              
                    <div >
                        <InnerBlocks.Content
                        />
                    </div>
              
            </div>
        )
    }
})